import { render, staticRenderFns } from "./Aneel3_XMLInicio.vue?vue&type=template&id=5a68eb50&"
import script from "./Aneel3_XMLInicio.vue?vue&type=script&lang=js&"
export * from "./Aneel3_XMLInicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports